<div
  class="h-2 rounded-full bg-black/5 dark:bg-white/10 border border-white/30 overflow-hidden"
>
  <div [class]="fillClasses()" [style.width.%]="clampedValue()"></div>
</div>
